import { Button } from '@ixigo/iui/button';
import { Text } from '@ixigo/iui/text';
import type { ErrorComponentProps } from '@tanstack/react-router';

export function DefaultCatchBoundary({ error: _error }: ErrorComponentProps) {
	return (
		<div className="min-h-full flex flex-col">
			<div className="flex flex-col w-full p-3xl items-center text-center">
				<img
					src={
						'https://images.ixigo.com/image/upload/flight/error/light/no-internet'
					}
					alt="Error"
					className="max-w-sm w-full h-60"
				/>
				<Text
					variant="heading-xs"
					fontWeight="bold"
					fontFamily="serif"
					className="mt-20 mb-10"
				>
					Oops! Something went wrong
				</Text>
				<Text variant="para-sm" className="text-tertiary">
					Sorry! We cannot process your request at the moment. Please try again
					later.
				</Text>

				<DefaultErrorActions isOffline={false} />
			</div>
		</div>
	);
}

const DefaultErrorActions = ({ isOffline }: { isOffline: boolean }) => {
	if (isOffline) {
		return (
			<Button
				variant="solid"
				color="neutral"
				size="lg"
				onClick={() => window.location.reload()}
			>
				Refresh
			</Button>
		);
	}

	return (
		<div className="flex flex-col gap-lg px-3xl mt-8">
			<RetryButton />
		</div>
	);
};

export const RetryButton = ({
	children = 'Retry',
}: {
	children?: React.ReactNode;
}) => {
	const handleReset = () => {
		window.location.reload();
	};
	return (
		<Button variant="solid" color="neutral" size="lg" onClick={handleReset}>
			{children}
		</Button>
	);
};
